import { useSelector } from 'react-redux';
import { selectIsDisableAi } from '../../reducers/userInfoReducer';
import useAgentsSubscriptions from './useAgentsSubscriptions';

const useIsAnyAgentEnabled = () => {
  const isDisableAi = useSelector(selectIsDisableAi);
  const agentsSubscriptions = useAgentsSubscriptions();
  const isAtLeastOneAgentSubscription = Object.values(agentsSubscriptions).some((v) => v);

  return !isDisableAi && isAtLeastOneAgentSubscription;
};

export default useIsAnyAgentEnabled;
